import React, { useState, useEffect, useRef } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Input,
  Col,
  Form,
  Row,
  Popconfirm,
  Tooltip,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ErrorNotificationMsg, SuccessNotificationMsg} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import moment from "moment";
import DealDone from "../../image/DealDone.svg";
import Proposal from "../../image/Proposal.svg";
import OpenIcon from "../../image/OpenIcon.svg";
import Callcenter from "../../image/Callcenter.svg";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import ComparedIcon from "../../image/ComparedIcon.svg";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';

const VendorPurchaseSummary = () => {

  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const { rfqId } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [rfqStatus, setRfqStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formRef = useRef();
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeFilter, setCategoryTreeFilter] = useState("");
  const { id } = useParams();
  const [categoryId, setCategoryId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusCounts, setStatusCounts] = useState({
      total_purchase_order: 0,
      pending_for_approval: 0,
      send_for_approval: 0,
      approve_and_issued_order: 0,
      approve_and_prepare_draft_order: 0,
      rejected: 0,
      rejected_with_reason: 0,
      order_accepted_by_vendor: 0,
      order_rejected_by_vendor: 0
  });
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
//   useEffect(() => {
//     const getRFQHistory = async () => {
//       setLoading(true);

//       try {
//         let apiResponse = await getRequest(`po-order/?company_id=${CompanyId}`, state);
//         if (apiResponse.data.results.data) {
//           setRFQHistory(apiResponse.data.results.data);
//           settotalCount(apiResponse.data.count);
//         } else {
//           ErrorNotificationMsg(t("error_in_rfq_history"));
//         }
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//       }
//     };
//     const getStatusCount = async () => {
//           // setLoading(true);

//           try {
//               let apiResponse = await getRequest(`po-order/${CompanyId}/po-status-count/`, state);
//               console.log("Res", apiResponse);
//               if (apiResponse.data.success) {
//                   const message = apiResponse.data.data;
//                   setStatusCounts({
//                       total_purchase_order: message.total_purchase_order,
//                       pending_for_approval: message.pending_for_approval,
//                       send_for_approval: message.send_for_approval,
//                       approve_and_issued_order: message.approve_and_issued_order,
//                       approve_and_prepare_draft_order: message.approve_and_prepare_draft_order,
//                       rejected: message.rejected,
//                       rejected_with_reason: message.rejected_with_reason,
//                       order_accepted_by_vendor: message.order_accepted_by_vendor,
//                       order_rejected_by_vendor: message.order_rejected_by_vendor
//                   });
//               } else {
//                   ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
//               }
//               // setLoading(false);
//           } catch (error) {
//               //setLoading(false);
//           }
//       };

//     getRFQHistory();
//     getStatusCount();
//     getCategoryTree();
//   }, [reload, state, t]);
  
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setEndDate(formattedDate);
  };
  //
  const handleCategoryChange = (value) => {
    setCategoryTreeFilter(value);
  };

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
      }
    );
  };
  const handleReset = () => {
    setRfqStatus("");
    setEndDate("");
    setStartDate("");
    setCategoryTreeFilter("");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      po_created_date__lte: null,
    });
  };

    const handleClickCard = (value) => {
        setState({
            ...state,
            po_status: value,
            search: "",
            page: 1,
            // ordering: "id",
            pagesize: 10,
            total: 0,
        });
    };
//   const handleExcelDownload = async () => {
//     const endpoint1 = `float-rfq545545454/${CompanyId}/rfq-excel-download/`;
//     const endpoint = `po-order/${CompanyId}/po-order-excel-download/`;
//     const fileType = "csv";

//     try {
//       await getRequest(endpoint)
//         .then((response) => {
//           const blob = new Blob([response.data], {
//             type: "text/csv",
//           });
//           const link = document.createElement("a");
//           link.href = window.URL.createObjectURL(blob);
//           link.download = `float-rfq_${+new Date()}.${fileType}`;
//           link.click();
//         })
//         .catch((error) => {
//           //ErrorNotificationMsg(t(`err_${fileType}_download`));
//         });
//     } catch (error) {
//       //setBtnloading(false);
//       //ErrorNotificationMsg(error);
//     }
//   };

  const handleApplyFilter = () => {
    const filterParams = {
      po_created_date__gte: startDate,
      po_created_date__lte: endDate,
      category_id: categoryTreeFilter,
      rfq_detail: rfqStatus,
    };
    setState(filterParams);
  };


  const handleDownload = async (id, vendorId) => {
    console.log('id', id, 'vendorId', vendorId);
    
    // window.open(`/pdfdownload-purchase-requisition/details/pdf/${id}/${vendorId}`, "_blank")
    window.open(`/pdfdownload-purchase-order-details/pdf/${id}/${vendorId}`, "_blank")


    // try {
    //   const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
    //   const response = await getRequest(endpoint);
    //   const blob = new Blob([response.data], {
    //     type: "text/csv", // Set MIME type to text/csv for CSV file
    //   });
    //   const link = document.createElement("a");
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = `purchase_requisition_${prNumber}-${+new Date()}.csv`; // Set file extension to .csv
    //   link.click();
    // } catch (error) {
    //   // Error handling code removed
    // }
  };


  const columns = [
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      width: 120,
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      width: 110,
    },
    {
      title: "Vendor",
      dataIndex: "vendor_name",
      key: "vendor_name",
      width: 180
    },
    {
      title: "PO Date",
      dataIndex: "po_approval_date",
      key: "po_approval_date",
      width: 120,
      render: (text) => text !== null ? dayjs(text).format("DD-MM-YYYY") : "Pending",
    },
    {
      title: "Site Location",
      dataIndex: "rfq_site_names",
      key: "rfq_site_names",
      width: 170,
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      width: 200,
      render: (amount_without_gst) => {
          return (
            <p>
              {`\u20B9 ${amount_without_gst?.toFixed(2) || 0}`}
            </p>
          )
      },
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      width: 160,
      render: (amount_with_gst) => {
          return (
            <p>
              {`\u20B9 ${amount_with_gst?.toFixed(2) || 0}`}
            </p>
          )
        },
      
    },
    {
      title: "Status",
      dataIndex: "po_status",
      key: "po_status",
      width: 210,
    },
    {
      title: "Delivery Status",
      dataIndex: "delivery_status",
      key: "delivery_status",
      width: 160,
    },
    {
      title: "Action",
      fixed: "right",
      width: 80,
      render: (record) => {
        return (
          <Tooltip title="View & Download Purchase Order" color="#094E8F" placement="left">
            <DownloadOutlined onClick={() => handleDownload(record.id, record.vendor)} />
          </Tooltip>
        )}
    },
  ];

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
              <h3>{t("po_summary")} </h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("po_summary")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("Search by PO number")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
          </Space>
        </div>
      </div>
      <section className="grid-sec ">
        <div className="PR-body">
          <section className="Block-Sec-Demo mb-5">
            <Row gutter={[15]}>
              <Col xs={24} sm={12} md={6}>
                <div className="card mb-5"  onClick={() => {
                    handleClickCard("Approve and Issued Order");
                }}>
                  <div className="card-block block-1">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={OpenIcon} alt="Open" width={35} />
                        {/* <p>{statusCounts.openCount}</p> */}
                      </div>
                      <div className="card-description">
                        <h3> Order Issued </h3>
                        <p>{statusCounts.approve_and_issued_order}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="card mb-5"  onClick={() => {
                    handleClickCard("Order Accepted By Vendor");
                }}>
                  <div className="card-block block-2">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={Callcenter} alt="Callcenter" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-orange">  Order Accepted </h3>
                        <p>{statusCounts.order_accepted_by_vendor}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="card mb-5"  onClick={() => {
                    handleClickCard("Rejected");
                }}>
                  <div className="card-block block-3">
                    <div className="card-box">
                      <div className="card-icon">
                        <img src={Proposal} alt="Proposal" width={35} />
                      </div>
                      <div className="card-description">
                        <h3 className="color-purpul"> Order Rejected </h3>
                        <p>{statusCounts.rejected}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

            </Row>
          </section>
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>

                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item
                      name="po_created_date__gte"
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        showTime={true}
                        placeholder="Select start date"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="po_created_date__lte">
                      <DatePicker
                        format="DD-MM-YYYY"
                        showTime={true}
                        placeholder="Select end date"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                {endDate || startDate || categoryTreeFilter || rfqStatus ? (
                  <>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Apply"
                      label="Apply"
                      onClick={handleApplyFilter}
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      label="Reset"
                      onClick={handleReset}
                    />

                  </>
                ) : ""}
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Excel"
                  label="Excel"
                //   onClick={handleExcelDownload}
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                />
              </Space>
            </div>
          </div>
          <Table
            columns={columns}
            // rowSelection={rowSelection}
            dataSource={rfqHistory}
            rowKey={(record) => record.id}
            scroll={{
              x: 900,
            }}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: 'Items / Page', 
              },
            }}
            onChange={handleTableChange}
          />
        </div>
      </section>
    </>
  );
};
export default VendorPurchaseSummary;
